import type { ApiServiceConfig } from "~/services/ApiBaseService";
import { ApiBaseService } from "~/services/ApiBaseService";
import { CarerixPartnerApi } from "~/services/partners/CarerixPartnerApi";
import { PartnerTenantService } from "~/services/partners/PartnerTenantService";

export class PartnerApiContainer extends ApiBaseService {
    public tenants: PartnerTenantService;

    constructor(config: ApiServiceConfig) {
        super(config);

        this.tenants = new PartnerTenantService(this.getConfig());
    }

    public carerix(tenant: string, userId: string): CarerixPartnerApi {
        return new CarerixPartnerApi(this.getConfig(), tenant, userId);
    }
}
